export const STATUS_LABELS = {
  recue: "Demande reçue",
  devis_envoye: "Devis envoyé",
  payee: "Payée",
  terminee: "Terminée & renvoyée",
  annulee: "Annulée",
};

export const STATUS_STEPS = ["recue", "devis_envoye", "payee", "terminee"];

export const PRESTATIONS = [
  "Clonage Calculateur (remplacement à l'identique)",
  "Reprogrammation Stage 1 (Gain Puissance & Couple)",
  "Dépollution Logicielle (EGR, FAP, AdBlue)",
  "Réparation & Suppression Anti-démarrage (Immo Off)",
  "Clonage & Réparation TCU (boîte de vitesses automatique)",
  "Calculateur Airbag (effacement crash data, réparation)",
  "Compteur (réparation affichage, aiguilles, clonage)",
];

export const REFERENCE_CONFIG = [
  {
    match: ["TCU"],
    label: "Référence TCU (ex: DQ200, 0AM927769D)",
    placeholder: "TCU DQ200 / 8HP / EDC...",
  },
  {
    match: ["Airbag"],
    label: "Référence calculateur airbag (ex: 0285010...)",
    placeholder: "Bosch / Continental / Autoliv airbag...",
  },
  {
    match: ["Compteur"],
    label: "Référence compteur (inscription au dos du bloc)",
    placeholder: "Référence compteur / VDO / Magneti...",
  },
];

export const DEFAULT_REFERENCE = {
  label: "Référence Calculateur moteur (ex: 0281013328)",
  placeholder: "Bosch EDC16C34 / Continental...",
};

export function getReferenceConfig(prestation) {
  return (
    REFERENCE_CONFIG.find((c) => c.match.some((m) => prestation.includes(m))) ||
    DEFAULT_REFERENCE
  );
}

export const ENERGIES = ["Diesel", "Essence", "Hybride", "Électrique", "GPL"];
